import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import HtmlEditPanel from './HtmlEditPanel.js';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import 'lodash';
import '../defaults.js';
import '../AdsenseTitle.js';
import '../style-inject.es-746bb8ed.js';

const HtmlEditPanelTiptap = ({ componentData, updateData, close }) => {
  const { t, theme } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    HtmlEditPanel,
    {
      componentData,
      t,
      theme,
      close,
      updateData
    }
  );
};

export { HtmlEditPanelTiptap as default };
//# sourceMappingURL=HtmlEditPanelTiptap.js.map
